/** Flip to true to show /copytrade hub button + page again. Code stays intact. */
export const SHOW_COPYTRADE = false;

export const LINKS = {
  giveawayChannel: "https://t.me/GiveawayLuqmanan",
  officialChannel: "https://t.me/+ebm3lk2YpG0wZmFl",
  sofiaBot: "https://t.me/SofiaRumahBiruBot?start=web",
  broker: "https://ma.phyntex-markets.com/ib/?partner=UgeyIxMTcxIjpmYWxzZX0vo",
  instagram: "https://www.instagram.com/luqmanan_",
};

const PUBLIC = process.env.PUBLIC_URL || "";

export const ASSETS = {
  heroVideo:
    process.env.REACT_APP_HERO_VIDEO_URL ||
    "https://luqmanan.b-cdn.net/LUQMANAN%20INTRO.mp4",
  videoPoster: "https://luqmanan.b-cdn.net/IMG_1854.JPG",
  profilePhoto: `${PUBLIC}/luqmanan-profile.png`,
  logoBanner:
    "https://luqmanan.b-cdn.net/8148A81E-A19C-4E9F-9AAF-57045654B46C.PNG",
  giveawayBanner:
    "https://luqmanan.b-cdn.net/feedback/D0AB3C0B-4EAA-4802-8491-2382571F3751.PNG",
  giveawayFeedback: [
    "https://luqmanan.b-cdn.net/feedback/IMG_2682%202.PNG",
    "https://luqmanan.b-cdn.net/feedback/IMG_2683%202.PNG",
    "https://luqmanan.b-cdn.net/feedback/IMG_2684%202.PNG",
    "https://luqmanan.b-cdn.net/feedback/IMG_2685%202.PNG",
    "https://luqmanan.b-cdn.net/feedback/IMG_2805.jpg",
    "https://luqmanan.b-cdn.net/feedback/IMG_2806.jpg",
  ],
};
